/**
 * Top-right minimap HUD — fixed in canvas-pixel space, independent of the
 * camera. Extracted from GameCanvas.jsx (iteration 27). Behavior-preserving.
 */
const WORLD_W = 1280;
const WORLD_H = 820;

export function drawMiniMapHUD(ctx, st) {
  const MAP_W = 220;
  const MAP_H = 144;
  const MARGIN = 16;
  const MX = (WORLD_W - MAP_W - MARGIN);
  const MY = MARGIN;
  ctx.save();

  // Frame
  ctx.fillStyle = "rgba(0,0,0,0.78)";
  ctx.fillRect(MX - 6, MY - 6, MAP_W + 12, MAP_H + 22);
  ctx.strokeStyle = "#FFCC00";
  ctx.lineWidth = 4;
  ctx.strokeRect(MX - 6, MY - 6, MAP_W + 12, MAP_H + 22);
  // Title strip
  ctx.fillStyle = "#FFCC00";
  ctx.font = "bold 11px 'Press Start 2P', monospace";
  ctx.textAlign = "center";
  ctx.textBaseline = "top";
  ctx.fillText("TRACK", MX + MAP_W / 2, MY - 4);

  // Inner background
  ctx.fillStyle = "#1a3322";
  ctx.fillRect(MX, MY + 14, MAP_W, MAP_H);

  const sx = MAP_W / WORLD_W;
  const sy = MAP_H / WORLD_H;
  const mx = (wx) => MX + wx * sx;
  const my = (wy) => MY + 14 + wy * sy;

  // Road hint bands
  ctx.fillStyle = "#3f3f4f";
  ctx.fillRect(MX, MY + 14 + (WORLD_H / 2) * sy - 4, MAP_W, 8);
  ctx.fillRect(MX + (WORLD_W / 2) * sx - 4, MY + 14, 8, MAP_H);

  // Items
  for (const it of st.items) {
    ctx.fillStyle = it.collected ? "rgba(255,200,80,0.25)" : "#FFCC00";
    const ix = mx(it.x), iy = my(it.y);
    ctx.fillRect(ix - 2, iy - 2, 5, 5);
    if (!it.collected) {
      const r = 4 + Math.sin(performance.now() / 250) * 1.5;
      ctx.strokeStyle = "rgba(255, 220, 80, 0.6)";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.arc(ix, iy, r + 2, 0, Math.PI * 2);
      ctx.stroke();
    }
  }

  // Boost gates
  for (const g of st.gates) {
    if (g.used) continue;
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(mx(g.x) - 1, my(g.y) - 1, 3, 3);
  }

  // Cops / FBI
  for (const e of st.enemies) {
    ctx.fillStyle = e.kind === "fbi" ? "#3070FF" : "#FF3030";
    ctx.fillRect(mx(e.x) - 1.5, my(e.y) - 1.5, 4, 4);
  }

  // Player — green arrow showing facing direction
  const pX = mx(st.player.x), pY = my(st.player.y);
  ctx.save();
  ctx.translate(pX, pY);
  ctx.rotate(st.player.angle);
  ctx.fillStyle = "#4AE863";
  ctx.beginPath();
  ctx.moveTo(6, 0);
  ctx.lineTo(-4, -4);
  ctx.lineTo(-4, 4);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = "#000";
  ctx.lineWidth = 1;
  ctx.stroke();
  ctx.restore();

  ctx.restore();
}
